export var EmdGender;
(function (EmdGender) {
    EmdGender["female"] = "F";
    EmdGender["male"] = "M";
    EmdGender["unknown"] = "U";
    EmdGender["other"] = "I";
})(EmdGender || (EmdGender = {}));
EmdGender['female'] = 'F';
EmdGender['male'] = 'M';
EmdGender['unknown'] = 'U';
EmdGender['other'] = 'I';
//# sourceMappingURL=EmdGender.js.map